import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'

import { type AuthorizedPoi, hasAuthorizedPoisAcrossProfiles } from '../helpers/has-authorized-pois-across-profiles'

import { useGetPaymentProfiles } from './use-get-payment-profiles'

interface UseHasAuthorizedPoisAcrossProfilesResult {
  hasAuthorizedPois: boolean
  isLoading: boolean
}

export function useHasAuthorizedPoisAcrossProfiles(pois: AuthorizedPoi[]): UseHasAuthorizedPoisAcrossProfilesResult {
  const { deusExMachina } = useDeusExMachina()
  const stoneAccountId = deusExMachina?.entity?.stoneAccount?.id ?? ''
  const { data: paymentProfiles, isInitialLoading } = useGetPaymentProfiles({ stoneAccountId })

  return {
    hasAuthorizedPois: hasAuthorizedPoisAcrossProfiles(paymentProfiles, pois),
    isLoading: isInitialLoading
  }
}
